export function getUniqueCategories(facilities) {
  const categories = facilities.map(facility => facility.categoryCode).filter(category => category)
  return [...new Set(categories)]
}
